export const githubEndpoint = "https://api.github.com/graphql"

export const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN
